import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_COLLECTIONS_ITEMS, PROGRAM_MOVIES_ITEMS, TRANSLATION } from '../constants/state'
import filterMoviesToday from '../functions/filterMoviesToday'
import getMomentNow from '../functions/getMomentNow'
import CollectionItemsAccess from './CollectionItemsAccess'

const mapStateToProps = (state, ownProps) => ({
    collection: getData(state, [PROGRAM_COLLECTIONS_ITEMS, ownProps.collectionId]),
    movies: getData(state, PROGRAM_MOVIES_ITEMS),
    translation: getData(state, TRANSLATION), 
})

const CollectionMoviesTodayAccess = ({
    htmlId,
    collectionId,
    collection,
    movies,
    filterType,
    filterValue,
    translation
}) => {
    const nowObject = getMomentNow(translation.timezone)
    const items = filterMoviesToday(collection.items, movies, nowObject, translation.timezone, filterValue)

    return (
        <CollectionItemsAccess
            htmlId={htmlId}
            collectionId={collectionId}
            items={items}
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(CollectionMoviesTodayAccess)